import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const PanelTitleStyled = styled.h2`
  font-size: 2.4rem;
  line-height: 3.2rem;
  font-weight: 700;
  color: ${colors.neutral[900]};
  margin-bottom: 0.8rem;
  margin-top: 0;
`;

export const ContentWrapperStyled = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ProposalInfoListStyled = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: ${colors.neutral[700]};
  letter-spacing: 0.02rem;
`;

export const InfoKeyStyled = styled.span`
  font-weight: 700;
  margin-right: 0.5rem;
`;

export const InfoValueStyled = styled.span`
  word-break: break-word;
`;

export const ActionSectionStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
  gap: 1.5rem;
`;
